import type { InitAppForPageFn } from '@wix/yoshi-flow-editor';

import { ProfileSubject } from './services/profile-subject';
import type { ProfileCardAPI } from './types';

const profileSubject = new ProfileSubject();

export const initAppForPage: InitAppForPageFn = async () => ({
  profileSubject,
});

export const exports = (): ProfileCardAPI => ({
  registerToProfileChange: (callback) => {
    profileSubject.registerObserver(callback);
  },
});
